let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hs3yK")).then(() => parcelRequire('6VrHr'));